import Colors from 'bit/mobiauto.web-ui-components.components.colors/colors';

export const styles = theme => ({
  itemsMenu: {
    color: '#fff',
    '&:hover': {
      backgroundColor: '#f00 !important',
    },
  },
  noSelectedItem: {
    fill: `#fff!important`,
    color: `#fff !important`,
    fontSmoothing: 'auto!important',
    minWidth: 'initial',
  },
  selectedItem: {
    color: `#fff !important`,
    fill: `#fff !important`,
    backgroundColor: 'transparent!important',
    fontSmoothing: 'auto!important',
    minWidth: 'initial',
  },
  menuIcon: {
    color: `#fff !important`,
    fill: `#fff !important`,
    backgroundColor: 'transparent!important',
    fontSmoothing: 'auto!important',
    minWidth: 'initial',
    marginRight: 20,
    position: 'relative',
  },
  selectedRoot: {
    fill: `#fff !important`,
    backgroundColor: '#ffffff30 !important',
    borderLeft: `4px solid ${theme.palette.primary.main ||
      Colors.primary.light}`,
  },
  selectedRootClosed: {
    fill: `#fff !important`,
    backgroundColor: '#ffffff30 !important',
    // borderLeft: `4px solid ${theme.palette.primary.main ||
    //   Colors.primary.light}`,
  },
  feirao: {
    backgroundColor: '#E5E5E5 !important',
    color: '#333333',
  },
  feiraoItem: {
    color: '#333333',
  },
  rootClose: {
    color: '#fff !important',
    paddingLeft: '24px !important',
    '&:hover': {
      backgroundColor: '#ffffff30 !important',
    },
    cursor: 'pointer',
  },
  root: {
    color: '#fff !important',
    '&:hover': {
      backgroundColor: '#ffffff30 !important',
    },
    cursor: 'pointer',
  },
  subItem: {
    color: `${Colors.primary.medium}!important`,
    border: 0,
    fontSize: '12px',
    backgroundColor: `#ffffff30 !important`,
    borderLeft: `2px solid ${theme.palette.primary.main ||
      Colors.primary.light} !important`,
  },
  subsubItem: {
    border: 0,
    backgroundColor: 'transparent !important',
    color: `${theme.palette.primary.main || Colors.primary.light}  !important`,
  },
  subItemIcon: {
    marginRight: '0px!important',
    marginLeft: '24px!important',
  },
  rootSubItem: {
    color: Colors.gray.medium,
    fill: `${theme.palette.primary.main || Colors.primary.medium}!important`,
    fontSize: '12px',
  },
  selectedItemSubMenu: {
    color: `#fff !important`,
    backgroundColor: 'transparent!important',
  },
  colorSubItem: {
    color: Colors.gray.medium,
  },
  subsubItemSelected: {
    border: 0,
    backgroundColor: 'transparent !important',
    color: `${theme.palette.primary.main || Colors.primary.light}  !important`,
  },
  firstLevel: {
    padding: '0 0 10px 0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    borderTop: '1px solid #fff !important',
  },
  firstLevelChanged: {
    padding: '48px 0 10px 0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
  },
});
